import { Box, Grid, Typography } from "@mui/material";
import logo from "../../assets/images/Latest Logo.png";
import styles from "./HomeNew.module.css";
import { useNavigate } from "react-router-dom";
import Footer from "./HomeFooter";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { PiBuildings } from "react-icons/pi";
import search_resume from "../../assets/images/imresizer-1725592303056.jpg";
import profile_image1 from "../../assets/images/profile-picture 1.jpg";
import profile_image2 from "../../assets/images/profile-picture 2.jpg";
import profile_image3 from "../../assets/images/profile-picture 3.jpg";
import profile_image4 from "../../assets/images/profile-picture 4.jpg";
import profile_image5 from "../../assets/images/profile-picture 5.jpg";
import { IoIosArrowRoundBack } from "react-icons/io";
import { IoIosArrowRoundForward } from "react-icons/io";
import review_image from "../../assets/images/One Image.jpg";
import write from "../../assets/images/Write.gif";
import { useState } from "react";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoStar } from "react-icons/io5";
import { IoStarOutline } from "react-icons/io5";
import { IoStarHalfOutline } from "react-icons/io5";
import Fade from "react-reveal/Fade";
import { GoLightBulb } from "react-icons/go";

const FeedbackMore = ({ title, progress, color }) => {
  const naviagte = useNavigate();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const gender = [
    {
      value: "Male",
      label: "Male",
    },
    {
      value: "Female",
      label: "Female",
    },
    {
      value: "Other",
      label: "Other",
    },
  ];

  return (
    <Box>
         <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>

        <span className={styles.nav_links}>
          <a onClick={() => navigate("/")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b style={{ marginLeft: "10px", fontSize: "16px ", fontWeight:"500" }}>Home</b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "18px" }} />
            <b style={{ marginLeft: "5px", fontSize: "16px ", fontWeight:"500" }}>Our Platform</b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b style={{ marginLeft: "10px", fontSize: "16px ", fontWeight:"500" }}>About us</b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b style={{ marginLeft: "10px", fontSize: "16px ", fontWeight:"500" }}>Contact us</b>
          </a>
          <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                <b>Login</b>
              </a>
            </Box>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("/")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px  ",
                  fontWeight: "500",
                }}
              >
                Home
              </b>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "20px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </b>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                About us
              </b>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <b
                style={{
                  marginLeft: "10px",
                  fontSize: "16px ",
                  fontWeight: "500",
                }}
              >
                Contact us
              </b>
            </a>
            <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                <b>Login</b>
              </a>
            </Box>
          </Box>
        )}
      </Box>
      <Box sx={{ padding: "35px" }} id="home" />

      <Box className={styles.home_structure}>
        <Fade bottom delay={200}>
          <Box className={styles.heading_contain}>
            <b>Last 03 months feedback from Users</b>
          </Box>
          <Box className={styles.feedback_more_section} id="platform">
            {/* <Box sx={{ width: "30%" }}>

                    </Box> */}
            <Grid container sx={{ width: "98%" }}>
              <Grid
                item
                xs={12}
                sm={6}
                md={5}
                lg={5}
                className={styles.feedback_details}
              >
                <Box sx={{ width: "110%" }}>
                  <Box className={styles.servies_more_requirement}>
                    <img
                      src={write}
                      alt=""
                      width="90px"
                      height="90px"
                      style={{ marginLeft: "10px" }}
                    />
                    <span style={{ marginTop: "20px" }}>
                      <button
                        style={{ marginBottom: "30px" }}
                        className={styles.centerButton}
                        onClick={() => navigate("/login")}
                      >
                        Write Review
                      </button>
                      <Box sx={{ marginBottom: "20px" }}>
                        <IoStar
                          style={{ fontSize: "23px", color: "#fccc51" }}
                        />
                        <IoStar
                          style={{ fontSize: "23px", color: "#fccc51" }}
                        />
                        <IoStar
                          style={{ fontSize: "23px", color: "#fccc51" }}
                        />
                        <IoStar
                          style={{ fontSize: "23px", color: "#fccc51" }}
                        />
                        <IoStar
                          style={{ fontSize: "23px", color: "#fccc51" }}
                        />
                      </Box>
                      <Typography>
                        <b>
                          <Typography sx={{ fontSize: "17px !important" }}>
                            {" "}
                            <b>Always our user top priority for us. </b>
                          </Typography>
                        </b>
                      </Typography>
                      <Typography
                        sx={{
                          marginBottom: "50px",
                          fontSize: "16px !important",
                        }}
                      >
                        Dear user please share your feedback to improve our
                        service quality.
                      </Typography>
                    </span>
                    <span style={{ marginBottom: "50px" }}>
                      <img
                        src={review_image}
                        alt=""
                        style={{
                          width: "100%",
                          height: "auto",
                          maxWidth: "375px",
                          maxHeight: "100px",
                        }}
                      />
                    </span>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={7} lg={7} sx={{ padding: "20px " }}>
                <div>
                  <span className={styles.second}>
                    <Box>
                      <img
                        src={profile_image1}
                        alt=""
                        width="55px"
                        height="55px"
                        style={{
                          borderRadius: "50%",
                          marginRight: "20px",
                          border: "3.5px solid #d9d9d9",
                        }}
                      />
                      <span style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            <b>Mahesh Bhatt – IT Recruiter </b>
                          </Typography>
                          <Box>
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                           <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                          </Box>
                        </Box>
                        <a>
                          <Typography
                            sx={{
                              color: "gray",
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            Date: 10 –June 2024
                          </Typography>
                        </a>
                      </span>
                    </Box>
                    <span>
                      <Typography
                        sx={{
                          paddingTop: "5px",
                          fontSize: {
                            xs: "14px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        It’s easy to use. tracking of CandidateS and
                        requirements is so easy and this is very interactive in
                        both directions via the ATS with them. This improves the
                        performance of candidates, and limits admin activity.
                        <br />
                      </Typography>
                    </span>
                  </span>
                  <br />
                  <span className={styles.second}>
                    <Box>
                      <img
                        src={profile_image2}
                        alt=""
                        width="55px"
                        height="55px"
                        style={{
                          borderRadius: "50%",
                          marginRight: "20px",
                          border: "3.5px solid #d9d9d9",
                        }}
                      />

                      <span style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            <b>Ankita Tiwari– IT Recruiter </b>
                          </Typography>
                          <Box>
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                           <IoStar
                              style={{ fontSize: "20px", color: "#b8b7b7" }}
                            />
                          </Box>
                        </Box>
                        <a>
                          <Typography
                            sx={{
                              color: "gray",
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            Date: 17 –July 2024{" "}
                          </Typography>
                        </a>
                      </span>
                    </Box>
                    <span>
                      <Typography
                        sx={{
                          paddingTop: "5px",
                          fontSize: {
                            xs: "14px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        My overall experience is very positive, its helping to
                        me tracking my contract candidates and requirement along
                        with every details also its very easy to use even a
                        fresher recruiter can use easily as per my opinion it’s
                        enough thank you povital.com
                        <br />
                      </Typography>
                    </span>
                  </span>
                  <br />
                  <span className={styles.second}>
                    <Box>
                      <img
                        src={profile_image3}
                        alt=""
                        width="55px"
                        height="55px"
                        style={{
                          borderRadius: "50%",
                          marginRight: "20px",
                          border: "3.5px solid #d9d9d9",
                        }}
                      />
                      <span style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            <b>Nikhil Mishra– Bench Sales Recruiter</b>
                          </Typography>
                          <Box>
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                          </Box>
                        </Box>
                        <a>
                          <Typography
                            sx={{
                              color: "gray",
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            Date: 19 –July 2024
                          </Typography>
                        </a>
                      </span>
                    </Box>
                    <span>
                      <Typography
                        sx={{
                          paddingTop: "5px",
                          fontSize: {
                            xs: "14px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        The interface is user friendly and is very efficient for
                        the recruitment process. The main features that we liked
                        about it are: 1 The main feature is user friendly
                        interface that makes it super easy for us and an
                        appropriate feature for an IT Recruiter and Bench Sale
                        Recruiter.
                        <br />
                      </Typography>
                    </span>
                  </span>
                  <br />
                  <span className={styles.second}>
                    <Box>
                      <img
                        src={profile_image4}
                        alt=""
                        width="55px"
                        height="55px"
                        style={{
                          borderRadius: "50%",
                          marginRight: "20px",
                          border: "3.5px solid #d9d9d9",
                        }}
                      />

                      <span style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            <b>David M– Bench Sales Recruiter</b>
                          </Typography>
                          <Box>
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                          </Box>
                        </Box>
                        <a>
                          <Typography
                            sx={{
                              color: "gray",
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            Date: 19 –July 2024{" "}
                          </Typography>
                        </a>
                      </span>
                    </Box>
                    <span>
                      <Typography
                        sx={{
                          paddingTop: "5px",
                          fontSize: {
                            xs: "14px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        Having actively user of Povital Job Board and
                        Application Tracking System (ATS) for the past few days
                        in my role as an IT Recruiter, I'm pleased to share my
                        first hand insights into the systems merits and
                        advantages. Povital ATS will played a crucial role in
                        our USA requirement operations, streamlining and smooth
                        operation system. the user interface is user-friendly,
                        intuitive.
                        <br />
                      </Typography>
                    </span>
                  </span>
                  <br />
                  <span className={styles.second}>
                    <Box>
                      <img
                        src={profile_image5}
                        alt=""
                        width="55px"
                        height="55px"
                        style={{
                          borderRadius: "50%",
                          marginRight: "20px",
                          border: "3.5px solid #d9d9d9",
                        }}
                      />
                      <span style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            <b>Pratik Pollari– Bench Sales Recruiter</b>
                          </Typography>
                          <Box>
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#fccc51" }}
                            />
                            <IoStar
                              style={{ fontSize: "20px", color: "#b8b7b7" }}
                            />
                          </Box>
                        </Box>
                        <a>
                          <Typography
                            sx={{
                              color: "gray",
                              fontSize: {
                                xs: "14px !important",
                                sm: "16px !important",
                              },
                            }}
                          >
                            Date: 20 –July 2024
                          </Typography>
                        </a>
                      </span>
                    </Box>
                    <span>
                      <Typography
                        sx={{
                          paddingTop: "5px",
                          fontSize: {
                            xs: "14px !important",
                            sm: "16px !important",
                          },
                        }}
                      >
                        I have been using Povital job board and ATS for almost 2
                        months and I would say just go for this service as it
                        offers plenty of services that make the life of a
                        recruiter quite easy. I use it for finding candidates
                        and tracking my candidate and requirement, collecting
                        their data, maintenance, interview reminders, etc. I
                        would rate 10 on a scale of 10, Thank You Povital Team.
                        <br />
                      </Typography>
                    </span>
                  </span>
                </div>
              </Grid>
            </Grid>
          </Box>
          <Box className={styles.next_btns}>
            <Box className={styles.add_back_btns}>
              <button
                onClick={() => navigate(-1)}
                style={{
                  border: "1.5px solid #4285f4",
                  marginRight: "10px",
                  padding: "4.5px 10px ",
                }}
              >
                <IoIosArrowRoundBack
                  style={{ fontSize: "25px", color: "#4285f4" }}
                />
              </button>
            </Box>
            <button
              onClick={() => navigate("/feedback-next")}
              style={{
                backgroundColor: "#3856a6 ",
                padding: "5.5px 5px 5.5px 10px ",
              }}
            >
              Next{" "}
              <IoIosArrowRoundForward
                style={{ fontSize: "25px", marginLeft: "5px" }}
              />
            </button>
          </Box>
        </Fade>
        <Box>
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

export default FeedbackMore;
